import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/",
    //   name: "home",
    //   component: Home
    // },
    {
      path: "/login",
      name: "login",
      component: () => import("@/components/Login.vue")
    },
    {
      path: "/",
      name: "surveyMenu",
      component: () => import("@/views/Menu.vue")
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/locations",
      name: "locations",
      component: () => import("./views/Locations/Locations.vue")
    },
    {
      path: "/locations/edit/:id",
      name: "editLocation",
      component: () => import("./views/Locations/EditLocation.vue")
    },
    {
      path: "/volunteers/manage",
      name: "MngVolunteers",
      component: () => import("./views/Volunteers/ManageVolunteers.vue")
    },
    {
      path: "/volunteers/:id",
      name: "volunteers",
      component: () => import("./views/Volunteers/Volunteers.vue")
    },
    {
      path: "/volunteers/edit/:volId/:locId",
      name: "editVolunteer",
      component: () => import("./views/Volunteers/EditVolunteer.vue")
    },
    {
      path: "/volunteers/add/:id",
      name: "addVolunteer",
      component: () => import("./views/Volunteers/AddVolunteer.vue")
    },
    {
      path: "/locations/add",
      name: "addLocation",
      component: () => import("./views/Locations/AddLocation.vue")
    },
    {
      path: "/volunteers/code/:volId/:locId",
      name: "volunteerCode",
      component: () => import("./views/Volunteers/VolunteerCode.vue")
    },
    {
      path: "/surveys",
      name: "surveyLocations",
      component: () => import("./views/Surveys/SurveyLocations.vue")
    },
    {
      path: "/survey/pin",
      name: "surveyPin",
      component: () => import("./views/Surveys/SurveyPin.vue")
    },
    {
      path: "/survey/add/:isNew",
      name: "surveyAdd",
      component: () => import("./views/Surveys/SurveyMode.vue")
    },
    {
      path: "/survey/submit",
      name: "submitPastSurvey",
      component: () => import("./views/Surveys/PastSurvey.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("auth_token");

  if (authRequired && !loggedIn) {
    return next({ path: "/login", query: { returnUrl: to.path } });
  }
  next();
});

export default router;
